"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetAppletsOpenId = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var login_1 = require("../../model/login");
var service_1 = require("../../../library/base/service");
var GetAppletsOpenId = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(GetAppletsOpenId, _super);
    function GetAppletsOpenId() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '获取小程序openid';
        _this.code = '201142';
        _this.desc = '获取小程序openid';
        _this.requestParams = new login_1.GetAppletsOpenIdRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return GetAppletsOpenId;
}(service_1.BaseService));
exports.GetAppletsOpenId = GetAppletsOpenId;
//# sourceMappingURL=getAppletsOpenId.js.map